//import axios from 'axios';
import axios from "./axiosInstance";
import { Globals } from "../global/Globals";
import CryptoUtils from "../util/cryptoUtils";

export const fetchBriefs = async (proposalType, Filters, pageNumber) => {
  if (proposalType && Filters) {
    const body = {
      take: 5,
      skip: pageNumber,
      dataFilters: Filters,
      proposalType: proposalType,
    };
    const config = {
      headers: {
        "Content-Type": "application/json", // Set the Content-Type header
      },
    };

    const endpoint = Globals.BASE_URL + Globals.ENDPOINT.BRIEFS;
    const apiResponse = await axios.post(endpoint, body, config);
    return apiResponse;
  }
};

export const ProposolsCount = async (propsalstype, duration) => {
  const selectedRoleId = CryptoUtils.getFromLocalStorage("roleId")?.toString();
  const data = {
    proposalType: propsalstype,
    periodFilter: duration,
  };
  const config = {
    headers: {
      "Content-Type": "application/json", // Set the Content-Type header
    },
  };

  const endpoint = Globals.BASE_URL + Globals.ENDPOINT.PROPOSALS_COUNT + "?clusterId=0&roleId=" + selectedRoleId;;
  const apiResponse = await axios.post(endpoint, data, config);
  return apiResponse;
};
export const fetchFilterByCreatedBynewUser = async (roleID, clusterId) => {
  const config = {
    headers: {
      'Content-Type': 'application/json' // Set the Content-Type header
    }
  };
  const endpoint = Globals.BASE_URL + Globals.ENDPOINT.FILTER_BY_REPORTINGTO + "?roleIds=" + roleID.join('&roleIds=') + "&clusterIds=" + clusterId.join('&clusterIds=');
  const apiResponse = await axios.get(endpoint, config);
  return apiResponse;
}

export const ccProposolsCount = async (propsalstype, duration, clusterId) => {
  const selectedRoleId = CryptoUtils.getFromLocalStorage("roleId")?.toString();
  const data = {
    proposalType: propsalstype,
    periodFilter: duration,
  };
  const config = {
    headers: {
      "Content-Type": "application/json", // Set the Content-Type header
    },
  };

  const endpoint = Globals.BASE_URL + Globals.ENDPOINT.PROPOSALS_COUNT + "?clusterId=" + clusterId + "&roleId=" + selectedRoleId;
  const apiResponse = await axios.post(endpoint, data, config);
  return apiResponse;
};

export const deleteUnsolicitedProposalById = async (proposalId, type) => {
  if (proposalId) {
    const endpoint =
      Globals.ENDPOINT.DELETE_UNSOLICITED_PROPOSAL +
      "?proposalId=" +
      proposalId +
      "&" +
      "producerId=" +
      Globals.producerId;
    const apiResponse = await axios.delete(endpoint);
    return apiResponse;
  }
};

export const deleteSolicitedProposalById = async (proposalId, type) => {
  if (proposalId) {
    const endpoint = Globals.ENDPOINT.DELETE_SOLICITED_PROPOSAL + "?proposalId=" + proposalId;
    const apiResponse = await axios.delete(endpoint);
    return apiResponse;
  }
};
export const fetch_Proposals = async (Filters, pageNumber) => {
  const data = {
    take: 20,
    skip: pageNumber,
    dataFilters: Filters,
  };

  const config = {
    headers: {
      "Content-Type": "application/json", // Set the Content-Type header
    },
  };

  const endpoint = Globals.BASE_URL + Globals.ENDPOINT.MY_PROPOSALS_DASHBOARD;
  const apiResponse = await axios.post(endpoint, data, config);
  return apiResponse;
};

export const fetch_All_Proposals = async (Filters, pageNumber, RoleID) => {
  const fetch_all_proposals_endpoint =
    RoleID === Globals.USER_ROLES.CC
      ? Globals.ENDPOINT.FETCH_ALL_PROPOSALS
      : Globals.ENDPOINT.FETCH_ALL_CE_SOLICITED_PROPOSALS;
  const data = {
    take: 20,
    skip: pageNumber,
    dataFilters: Filters,
  };

  const config = {
    headers: {
      "Content-Type": "application/json", // Set the Content-Type header
    },
  };
  const endpoint = Globals.BASE_URL + fetch_all_proposals_endpoint;
  const apiResponse = await axios.post(endpoint, data, config);
  return apiResponse;
};

export const fetchFilterByCreatedBy = async (roleID, clusterId) => {
  const roleIds = roleID === Globals.USER_ROLES.SNR_MGR ? "?roleIds=4&roleIds=3&clusterId=" : "?roleIds=4&roleIds=3&roleIds=2&clusterId="
  const config = {
    headers: {
      "Content-Type": "application/json", // Set the Content-Type header
    },
  };
  const endpoint =
    Globals.BASE_URL +
    Globals.ENDPOINT.FILTER_BY_CREATEDBY + roleIds +
    clusterId;
  const apiResponse = await axios.get(endpoint, config);
  return apiResponse;
};

export const fetchFilterByCretedBy = async (roleID, clusterId) => {
  const config = {
    headers: {
      "Content-Type": "application/json", // Set the Content-Type header
    },
  };
  const endpoint =
    Globals.BASE_URL +
    Globals.ENDPOINT.FILTER_BY_CREATEDBY +
    "?roleIds=" +
    roleID +
    "&clusterId=" +
    clusterId;
  const apiResponse = await axios.get(endpoint, config);
  return apiResponse;
};

export const shelveBriefUpdate = async (body) => {
  const selectedRoleId = CryptoUtils.getFromLocalStorage("roleId")?.toString();
  const endpoint = Globals.ENDPOINT.BRIEF_SHELVE + "?roleId=" + selectedRoleId;
  const apiResponse = await axios.post(endpoint, body, Globals.CONFIG);
  return apiResponse;
};

export const getShelveBriefStatus = async (proposalId) => {
  const url = `${Globals.ENDPOINT.BRIEF_SHELVE_STATUS}?ProposalId=${proposalId}`;
  try {
    const apiResponse = await axios.get(url, Globals.CONFIG);
    return apiResponse;
  } catch (error) {
    console.error('Error in API call:', error);
  }
};

export const reactivateBriefUpdate = async (body) => {
  const selectedRoleId = CryptoUtils.getFromLocalStorage("roleId")?.toString();
  const endpoint = Globals.ENDPOINT.BRIEF_REACTIVE + "?roleId=" + selectedRoleId;
  const apiResponse = await axios.post(endpoint, body, Globals.CONFIG);
  return apiResponse;
};

export const reAssingBriefSubmit = async (reAssignBreifRequestBody) => {
  const apiResponse = await axios.post(Globals.ENDPOINT.RE_ASSIGN_BRIEF + '?roleId=' + CryptoUtils.getFromLocalStorage("roleId")?.toString(), reAssignBreifRequestBody);
  return apiResponse;
};

export const fetchFilterProposalStatus = async () => {
  const config = {
    headers: {
      "Content-Type": "application/json", // Set the Content-Type header
    },
  };
  const endpoint = Globals.BASE_URL + Globals.ENDPOINT.FILTER_BY_PROPOSALSTATUS;
  const apiResponse = await axios.get(endpoint, config);
  return apiResponse;
};

export const fetchFilterProposalStatusUnsolicited = async (roleID) => {
  const config = {
    headers: {
      "Content-Type": "application/json", // Set the Content-Type header
    },
  };
  const endpoint = Globals.BASE_URL + Globals.ENDPOINT.FILTER_BY_UNSOLICITED_STATUS + roleID;
  const apiResponse = await axios.get(endpoint, config);
  return apiResponse;
};

export const fetch_proposals_Briefs = async (proposalType, Filters, pageNumber) => {
  const data = {
    take: 20,
    skip: pageNumber,
    dataFilters: Filters,
    proposalType: proposalType,
  };

  const config = {
    headers: {
      "Content-Type": "application/json", // Set the Content-Type header
    },
  };
  const endpoint = Globals.BASE_URL + Globals.ENDPOINT.CONTENTCOORDINATOR + '?roleId=' + CryptoUtils.getFromLocalStorage("roleId")?.toString();
  const apiResponse = await axios.post(endpoint, data, config);
  return apiResponse;
};

export const fetch_All_Unsolicited_Proposals = async (Filters, pageNumber, RoleID) => {
  const fetch_all_proposals_endpoint =
    RoleID === Globals.USER_ROLES.CC
      ? Globals.ENDPOINT.FETCH_ALL_PROPOSALS_UNSOLICITED
      : Globals.ENDPOINT.FETCH_ALL_CE_UNSOLICITED_PROPOSALS;

  const data = {
    take: 20,
    skip: pageNumber,
    dataFilters: Filters,
  };

  const config = {
    headers: {
      "Content-Type": "application/json", // Set the Content-Type header
    },
  };

  const endpoint = Globals.BASE_URL + fetch_all_proposals_endpoint;
  const apiResponse = await axios.post(endpoint, data, config);
  return apiResponse;
};

export const fetch_All_SM_Proposals = async (Filters, pageNumber, RoleID) => {
  const data = {
    take: 20,
    skip: pageNumber,
    dataFilters: Filters,
  };

  const config = {
    headers: {
      "Content-Type": "application/json", // Set the Content-Type header
    },
  };
  const endpoint = Globals.BASE_URL + Globals.ENDPOINT.FETCH_SM_SOLICITED_PROPOSALS;
  const apiResponse = await axios.post(endpoint, data, config);
  return apiResponse;
};

export const fetch_All_SM_Unsolicited_Proposals = async (Filters, pageNumber, RoleID) => {
  const data = {
    take: 20,
    skip: pageNumber,
    dataFilters: Filters,
  };

  const config = {
    headers: {
      "Content-Type": "application/json", // Set the Content-Type header
    },
  };

  const endpoint = Globals.BASE_URL + Globals.ENDPOINT.FETCH_SM_UNSOLICITED_PROPOSALS;
  const apiResponse = await axios.post(endpoint, data, config);
  return apiResponse;
};

export const fetchFilterByProducer = async (clusterId) => {
  const config = {
    headers: {
      'Content-Type': 'application/json' // Set the Content-Type header
    }
  };
  const endpoint = Globals.BASE_URL + Globals.ENDPOINT.FILTER_BY_PRODUCER + "?clusterId=" + clusterId;
  const apiResponse = await axios.get(endpoint, config);
  return apiResponse;
}
export const submitSMEvaluation = async (requestBody) => {
  const apiResponse = await axios.get(Globals.ENDPOINT.SM_EVALUATION_SUBMIT + "?proposalId=" + requestBody.proposalId + "&proposalDetailId=" + requestBody.proposalDetailId);
  return apiResponse;

}



export const fetch_companies = async (Filters, pageNumber) => {
  const data = {
    take: 20,
    skip: pageNumber,
    dataFilters: [Filters],
  };

  const config = {
    headers: {
      "Content-Type": "application/json", // Set the Content-Type header
    },
  };

  const endpoint = Globals.BASE_URL + Globals.ENDPOINT.FETCH_COMPANIES;
  const apiResponse = await axios.post(endpoint, data, config);
  return apiResponse;
};

export const fetch_individuals = async (Filters, pageNumber) => {
  const data = {
    take: 20,
    skip: pageNumber,
    dataFilters: [Filters],
  };

  const config = {
    headers: {
      "Content-Type": "application/json", // Set the Content-Type header
    },
  };

  const endpoint = Globals.BASE_URL + Globals.ENDPOINT.FETCH_INDIVIDUALS;
  const apiResponse = await axios.post(endpoint, data, config);
  return apiResponse;
};

export const fetch_internalMangamentclusters = async (Filters, pageNumber) => {
  const data = {
    take: 20,
    skip: pageNumber,
    dataFilters: Filters,
  };

  const config = {
    headers: {
      "Content-Type": "application/json", // Set the Content-Type header
    },
  };

  const endpoint = Globals.BASE_URL + Globals.ENDPOINT.FETCH_CLUSTERSINFO;
  const apiResponse = await axios.post(endpoint, data, config);
  return apiResponse;
};

export const fetch_internalmanagementusers = async (Filters, pageNumber) => {
  const data = {
    take: 20,
    skip: pageNumber,
    dataFilters: [Filters],
  };

  const config = {
    headers: {
      "Content-Type": "application/json", // Set the Content-Type header
    },
  };

  const endpoint = Globals.BASE_URL + Globals.ENDPOINT.FETCH_USERSINFO;
  const apiResponse = await axios.post(endpoint, data, config);
  return apiResponse;
};


export const fetchFilterByProducerBy = async (roleID, clusterId) => {
  const roleIds = roleID === Globals.USER_ROLES.PRODUCER ? "?roleIds=5&clusterId=" : "?roleIds=4&roleIds=3&roleIds=2&clusterId="
  const config = {
    headers: {
      "Content-Type": "application/json", // Set the Content-Type header
    },
  };
  const endpoint =
    Globals.BASE_URL +
    Globals.ENDPOINT.FILTER_BY_CREATEDBY + roleIds +
    clusterId;
  const apiResponse = await axios.get(endpoint, config);
  return apiResponse;
};


export const updateProposalTitle = async (proposalId, proposalDetailId, title) => {

  const selectedRoleId = CryptoUtils.getFromLocalStorage("roleId")?.toString();
  const endpoint = Globals.BASE_URL + Globals.ENDPOINT.UPDATE_PROPOSALTITLE + "proposalId=" + proposalId + "&proposalDetailId=" + proposalDetailId + "&proposalTitle=" + title + "&roleId=" + selectedRoleId;
  const apiResponse = await axios.put(endpoint);
  return apiResponse;

}

export const fetchFilterByProducerByType = async (clusterId, Type) => {
  const ProposalType = Type === 'Unsolicited' ? 'UnSolicited' : 'Solicited';
  const config = {
    headers: {
      'Content-Type': 'application/json' // Set the Content-Type header
    }
  };
  const endpoint = Globals.BASE_URL + Globals.ENDPOINT.PRODUCERBYCLUSTERBYTYPE + "?clusterId=" + clusterId + "&dashBoardProposalType=" + ProposalType;
  const apiResponse = await axios.get(endpoint, config);
  return apiResponse;
}

export const fetchGenrebyCluster = async (clusterId) => {
  const config = {
    headers: {
      'Content-Type': 'application/json' // Set the Content-Type header
    }
  };
  const endpoint = Globals.BASE_URL + Globals.ENDPOINT.GENRES_BY_CLUSTER + clusterId;
  const apiResponse = await axios.get(endpoint, config);
  const transformedResult = apiResponse.data.content.map((item) => ({
    id: item.genreId,
    name: item.genreName,
  }));
  apiResponse.data.genreInfo = transformedResult;
  return apiResponse;
}

export const fetchGenresAllproposals = async () => {
  const config = {
    headers: {
      'Content-Type': 'application/json' // Set the Content-Type header
    }
  };
  const endpoint = Globals.BASE_URL + Globals.ENDPOINT.ALL_GENRES;
  const apiResponse = await axios.get(endpoint, config);
  const transformedResult = apiResponse.data.content.map((item) => ({
    id: item.genreId,
    name: item.genreName,
  }));
  apiResponse.data.genreInfo = transformedResult;
  return apiResponse;
}